import { lazy } from 'react';

const PendingAdmCertificationConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/adm/certificates-verification',
			component: lazy(() => import('./PendingCertificationContainer'))
		}
	]
};

export default PendingAdmCertificationConfig;

